import en from "../locales/en";
import ar from "../locales/ar";

export const lang = (value) => {
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const userLang = localStorage.getItem("languageSet");

  const lang = userLang ? userLang : "en";
  switch (lang) {
    case "en":
      return en[value] ?? value;
    case "ar":
      return ar[value] ?? value;
    default:
      return value;
  }
};

export default lang;
